import { Component, OnInit } from '@angular/core';
import { AuthService } from './../models/auth.service';

@Component({
  selector: 'wego-unauthenticated',
  template: `
  <section class="content">
  <div class="col-md-12 text-center">
	<div class="panel panel-danger">
      <div class="panel-heading">
      Session Timeout
      </div>
      <div class="panel-body"><p>
           Your session has expired due to no activities on website. Please
            <a routerLink="/">Login</a> again.
          </p></div>
    </div>
    </div>
  </section>
  `,
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})
export class UnAuthenticatedComponent implements OnInit {
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.Logout();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/unauthenticated.component.ts